module.exports = __webpack_public_path__ + "img/service_icon.83b377ed.svg";